import React from 'react'

import { arrayOf, shape, string } from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import Item from './Components/Item/Item'

// Shared by the AI subscription landing (/ai-3d-model-generator) and the per-object AI
// generator landings (/ai-3d-model-generator/:object), which pass their copy from Rails.
// idPrefix namespaces the generated question/answer ids so two accordions on one page can
// never collide on aria-controls.
function FAQs({ title = '', subtitle = '', items = EMPTY_ARRAY, idPrefix = 'ai-landing-faq' }) {
  if (!items.length) return null

  return (
    <section className="ai-landing-faqs" aria-labelledby={`${idPrefix}-title`}>
      <div className="ai-landing-faqs__intro">
        <h2 id={`${idPrefix}-title`} className="ai-landing-faqs__title cgt-heading-500">{title}</h2>
        {subtitle && <p className="ai-landing-faqs__subtitle cgt-body-base">{subtitle}</p>}
      </div>
      <div className="ai-landing-faqs__list">
        {items.map((item, index) => (
          <Item
            key={item.question}
            idPrefix={idPrefix}
            index={index}
            question={item.question}
            answer={item.answer}
            defaultOpen={index === 0}
            showDivider={index < items.length - 1}
          />
        ))}
      </div>
    </section>
  )
}

FAQs.propTypes = {
  title: string,
  subtitle: string,
  items: arrayOf(shape({
    question: string.isRequired,
    answer: string.isRequired,
  })),
  idPrefix: string,
}

export default FAQs
